/**
 * Der GünniEis — einfarbiges Spaghetti-Eis-Schälchen-Symbol (Nudelberg mit
 * Sauce-Tupfen), einfärbbar über `farbe`. Zwei Zustände: gefüllt (gewertet) /
 * Umriss (nicht gewertet), dazwischen anteilig füllbar für Durchschnittswerte.
 *
 * Wird dort verwendet, wo eine einfärbbare, sehr kleine Fassung nötig ist:
 * Kartenmarker/-legende (eingefärbt nach Bewertungsstufe), Marken-Icon in
 * Kopfzeile/Landingpage sowie die 1..5-Auswahl in GuennieRating (eingabe).
 * Für die große, naturgetreu-farbige Illustration siehe GuennieEisBild.
 */
export function GuennieIcon({
  gefuellt,
  anteil = 1,
  groesse = 24,
  farbe = 'currentColor',
  titel,
}: {
  gefuellt: boolean;
  /** 0..1 — für anteilig gefüllte Icons bei Durchschnittswerten */
  anteil?: number;
  groesse?: number;
  farbe?: string;
  titel?: string;
}) {
  const clip = `guennie-clip-${Math.random().toString(36).slice(2)}`;
  const schuessel = 'M14 72 L86 72 L76 88 C76 88 64 92 50 92 C36 92 24 88 24 88 Z';
  const kuppel = 'M20 70 C20 48 32 34 50 34 C68 34 80 48 80 70 Z';
  const wellen = [
    'M27 46 Q35 42 43 46 Q51 50 59 46 Q67 42 73 46',
    'M24 54 Q32 50 40 54 Q48 58 56 54 Q64 50 70 54',
    'M22 62 Q30 58 38 62 Q46 66 54 62 Q62 58 68 62',
  ];
  const sauce = 'M46 42 C45 39 48 37 50 39 C52 37 55 39 54 42 C56 44 54 47 50 46 C46 47 44 44 46 42 Z';

  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 100 100"
      role="img"
      aria-label={titel}
      aria-hidden={titel ? undefined : true}
    >
      {titel ? <title>{titel}</title> : null}
      <defs>
        <clipPath id={clip}>
          <rect x="0" y="0" width={100 * Math.max(0, Math.min(1, anteil))} height="100" />
        </clipPath>
      </defs>
      {/* Umriss (Schüssel, Nudelberg, Sauce) immer sichtbar */}
      <g
        fill="none"
        stroke={farbe}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity={gefuellt ? 0.9 : 0.35}
      >
        <path d={schuessel} />
        <ellipse cx="50" cy="72" rx="36" ry="6" />
        <path d={kuppel} />
        {wellen.map((w) => (
          <path key={w} d={w} />
        ))}
        <path d={sauce} />
        <circle cx="60" cy="40" r="1.8" fill={farbe} stroke="none" />
      </g>
      {/* Füllung (ggf. anteilig) */}
      {gefuellt ? (
        <g clipPath={`url(#${clip})`}>
          <path d={schuessel} fill={farbe} opacity="0.85" />
          <ellipse cx="50" cy="72" rx="36" ry="6" fill={farbe} opacity="0.85" />
          <path d={kuppel} fill={farbe} opacity="0.85" />
        </g>
      ) : null}
    </svg>
  );
}
